<template>
  <div class="form">
    <div class="form__content">
      <IdentityQueueStepCounter />
      <h1 class="extra-large-headline">
        {{ $t('DofpForm.headline.header') }}
      </h1>
      <p class="bodycopy">
        {{ $t('DofpForm.body.body1') }}
      </p>

      <div class="questionnaire">
        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question1') }}
          </p>
          <p class="questionnaire__question">{{ questions.one.question }}</p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.one.answers"
              :key="answer"
              :group="questions.one"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[0] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[0].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[0] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[0].answer,
              }"
              @update:checked="
                () => updateResponse(0, answer, questions.one.question)
              "
            />
          </div>
        </section>

        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question2') }}
          </p>
          <p class="questionnaire__question">{{ questions.two.question }}</p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.two.answers"
              :key="answer"
              :group="questions.two"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[1] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[1].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[1] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[1].answer,
              }"
              @update:checked="
                () => updateResponse(1, answer, questions.two.question)
              "
            />
          </div>
        </section>

        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question3') }}
          </p>
          <p class="questionnaire__question">
            {{ questions.three.question }}
          </p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.three.answers"
              :key="answer"
              :group="questions.three"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[2] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[2].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[2] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[2].answer,
              }"
              @update:checked="
                () => updateResponse(2, answer, questions.three.question)
              "
            />
          </div>
        </section>

        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question4') }}
          </p>
          <p class="questionnaire__question">
            {{ questions.four.question }}
          </p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.four.answers"
              :key="answer"
              :group="questions.four"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[3] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[3].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[3] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[3].answer,
              }"
              @update:checked="
                () => updateResponse(3, answer, questions.four.question)
              "
            />
          </div>
        </section>

        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question5') }}
          </p>
          <p class="questionnaire__question">
            {{ questions.five.question }}
          </p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.five.answers"
              :key="answer"
              :group="questions.five"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[4] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[4].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[4] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[4].answer,
              }"
              @update:checked="
                () => updateResponse(4, answer, questions.five.question)
              "
            />
          </div>
        </section>

        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question6') }}
          </p>
          <p class="questionnaire__question">{{ questions.six.question }}</p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.six.answers"
              :key="answer"
              :group="questions.six"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[5] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[5].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[5] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[5].answer,
              }"
              @update:checked="
                () => updateResponse(5, answer, questions.six.question)
              "
            />
          </div>
        </section>

        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question7') }}
          </p>
          <p class="questionnaire__question">{{ questions.seven.question }}</p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.seven.answers"
              :key="answer"
              :group="questions.seven"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[6] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[6].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[6] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[6].answer,
              }"
              @update:checked="
                () => updateResponse(6, answer, questions.seven.question)
              "
            />
          </div>
        </section>

        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question8') }}
          </p>
          <p class="questionnaire__question">{{ questions.eight.question }}</p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.eight.answers"
              :key="answer"
              :group="questions.eight"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[7] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[7].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[7] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[7].answer,
              }"
              @update:checked="
                () => updateResponse(7, answer, questions.eight.question)
              "
            />
          </div>
        </section>
        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question9') }}
          </p>
          <p class="questionnaire__question">{{ questions.nine.question }}</p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.nine.answers"
              :key="answer"
              :group="questions.nine"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[8] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[8].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[8] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[8].answer,
              }"
              @update:checked="
                () => updateResponse(8, answer, questions.nine.question)
              "
            />
          </div>
        </section>

        <section>
          <p class="questionnaire__number">
            {{ $t('DofpForm.label.question10') }}
          </p>
          <p class="questionnaire__question">{{ questions.ten.question }}</p>
          <div class="questionnaire__answers">
            <QuestionnaireInput
              v-for="(answer, index) in questions.ten.answers"
              :key="answer"
              :group="questions.ten"
              :label="trimValueFromAnswer(answer)"
              :value="findValueFromAnswers(answer)"
              :isSelected="
                typeof responses[9] !== 'undefined'
                  && findValueFromAnswers(answer) === responses[9].answer
              "
              :class="{
                '--is-not-selected':
                  typeof responses[9] !== 'undefined'
                  && findValueFromAnswers(answer) !== responses[9].answer,
              }"
              @update:checked="
                () => updateResponse(9, answer, questions.ten.question)
              "
            />
          </div>
        </section>
      </div>

      <ButtonBase
        :isDisabled="!formValuesFilled || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="() => handleFormSubmit(3, 'dofp-buy')"
      >
        {{ $t('DofpForm.label.submitMyAnswers') }}
      </ButtonBase>
      <IdentityQueueNext />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

import { useGlobalStore } from '@/stores/globalStore';

import ButtonBase from '@/components/ui/buttons/ButtonBase.vue';
import Toggle from '@/components/ui/toggles/Toggle.vue';
import QuestionnaireInput from '@/components/ui/inputs/QuestionnaireInput.vue';
import IdentityQueueStepCounter from '@/components/layout/progress/IdentityQueueStepCounter.vue';
import IdentityQueueNext from '@/components/layout/progress/IdentityQueueNext.vue';
import useDofpCommon from '../useDofpCommon';

const { t } = useI18n();

const questions = computed(() => ({
  one: {
    question: t('DofpBuyForm3.question.question1'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question1A')}`,
      `B. ${t('DofpBuyForm3.answer.question1B')}`,
      `C. ${t('DofpBuyForm3.answer.question1C')}`,
    ],
  },
  two: {
    question: t('DofpBuyForm3.question.question2'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question2A')}`,
      `B. ${t('DofpBuyForm3.answer.question2B')}`,
      `C. ${t('DofpBuyForm3.answer.question2C')}`,
    ],
  },
  three: {
    question: t('DofpBuyForm3.question.question3'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question3A')}`,
      `B. ${t('DofpBuyForm3.answer.question3B')}`,
      `C. ${t('DofpBuyForm3.answer.question3C')}`,
    ],
  },
  four: {
    question: t('DofpBuyForm3.question.question4'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question4A')}`,
      `B. ${t('DofpBuyForm3.answer.question4B')}`,
      `C. ${t('DofpBuyForm3.answer.question4C')}`,
    ],
  },
  five: {
    question: t('DofpBuyForm3.question.question5'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question5A')}`,
      `B. ${t('DofpBuyForm3.answer.question5B')}`,
      `C. ${t('DofpBuyForm3.answer.question5C')}`,
    ],
  },
  six: {
    question: t('DofpBuyForm3.question.question6'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question6A')}`,
      `B. ${t('DofpBuyForm3.answer.question6B')}`,
      `C. ${t('DofpBuyForm3.answer.question6C')}`,
    ],
  },
  seven: {
    question: t('DofpBuyForm3.question.question7'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question7A')}`,
      `B. ${t('DofpBuyForm3.answer.question7B')}`,
      `C. ${t('DofpBuyForm3.answer.question7C')}`,
    ],
  },
  eight: {
    question: t('DofpBuyForm3.question.question8'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question8A')}`,
      `B. ${t('DofpBuyForm3.answer.question8B')}`,
      `C. ${t('DofpBuyForm3.answer.question8C')}`,
    ],
  },
  nine: {
    question: t('DofpBuyForm3.question.question9'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question9A')}`,
      `B. ${t('DofpBuyForm3.answer.question9B')}`,
      `C. ${t('DofpBuyForm3.answer.question9C')}`,
    ],
  },
  ten: {
    question: t('DofpBuyForm3.question.question10'),
    answers: [
      `A. ${t('DofpBuyForm3.answer.question10A')}`,
      `B. ${t('DofpBuyForm3.answer.question10B')}`,
      `C. ${t('DofpBuyForm3.answer.question10C')}`,
    ],
  },
}));

const {
  responses,
  updateResponse,
  findValueFromAnswers,
  trimValueFromAnswer,
  formValuesFilled,
  handleFormSubmit,
} = useDofpCommon(10);

const globalStore = useGlobalStore();
</script>

<style lang="scss" scoped>
@import '../dofpCommonStyles.scss';
</style>
